import { DownOutlined, ReloadOutlined } from '@ant-design/icons'
import { Button, Dropdown, Space, Typography } from 'antd'
import { formatRefreshSetting, formatUpdatedAt, RefreshSetting, refreshSettingOptions } from './longRunningTasksModel'

type Props = {
  setting: RefreshSetting
  autoInterval: number | false
  isFetching: boolean
  dataUpdatedAt: number
  onSettingChange: (setting: RefreshSetting) => void
  onRefresh: () => void
}

const RefreshControl = ({ setting, autoInterval, isFetching, dataUpdatedAt, onSettingChange, onRefresh }: Props) => {
  const updatedAt = formatUpdatedAt(dataUpdatedAt)

  return (
    <Space size={8}>
      {updatedAt && (
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          {updatedAt}
        </Typography.Text>
      )}
      <Space.Compact>
        <Button icon={<ReloadOutlined spin={isFetching} />} onClick={onRefresh} />
        <Dropdown
          trigger={['click']}
          menu={{
            items: refreshSettingOptions.map(option => ({ key: option.value, label: option.label })),
            selectable: true,
            selectedKeys: [setting],
            onClick: ({ key }) => onSettingChange(key as RefreshSetting),
          }}
        >
          <Button>
            {formatRefreshSetting(setting, autoInterval)} <DownOutlined />
          </Button>
        </Dropdown>
      </Space.Compact>
    </Space>
  )
}

export default RefreshControl
